import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-trash",
  "use": "icon-trash-usage",
  "viewBox": "100 100 800 800",
  "content": "<symbol class=\"icon\" viewBox=\"100 100 800 800\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-trash\"><path d=\"M764 208H656v-56H368v56H152v56h80v580a28 28 0 0 0 28 28h504a28 28 0 0 0 28-28V264h80v-56H764zM736 816H288V264h448v552z\" fill=\"#2c2c2c\" p-id=\"2856\" /><path d=\"M392 368h56v360h-56zM576 368h56v360h-56z\" fill=\"#2c2c2c\" p-id=\"2857\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol